module.exports = "/assets/about/success/academy.png?nTpmSSE";